import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchChartOfAccountsFullStructure } from '../../predict/src/core/api/chart-of-accounts';
import { COAFullStructureWithDisplayCodesFlag } from '../../predict/src/core/api/types/chart-of-accounts';
import { queryClient } from '../core/queryClient';

type ChartOfAccountsQueryOptions = Omit<
  QueryObserverOptions<COAFullStructureWithDisplayCodesFlag>,
  'queryKey' | 'queryFn'
>;

export const chartOfAccountsQueryKey = (organisationId: string, workspaceId: string) => [
  'chartOfAccounts',
  organisationId,
  workspaceId
];

export const chartOfAccountsQuery = (
  workspaceId: string,
  organisationId: string,
  options?: ChartOfAccountsQueryOptions
): QueryObserver<COAFullStructureWithDisplayCodesFlag> =>
  new QueryObserver<COAFullStructureWithDisplayCodesFlag>(queryClient, {
    queryKey: chartOfAccountsQueryKey(organisationId, workspaceId),
    queryFn: () => fetchChartOfAccountsFullStructure(workspaceId, organisationId),
    ...options
  });
